<ui-popup-layout>
  <ui-popup-body>
    <div #container class="tw-mt-2">
      <h2 class="tw-font-medium" translate>auth.sign_in.labels.title</h2>
      <p class="tw-pt-2 tw-pb-3 tw-text-base-text/60">{{ description$ | async }}</p>
      <div class="tw-mb-4">
        <form [formGroup]="form" (ngSubmit)="signIn()">
          <kendo-formfield uiShowErrorAfterBlur class="tw-mb-4">
            <kendo-label
              class="tw-pb-1 tw-text-lg tw-font-bold tw-text-base-text/60 tw-pointer-events-none"
              text="{{ 'auth.shared.labels.email' | translate }}" 
              [for]="email" 
            ></kendo-label>
            <input
              #email kendoTextBox
              autocomplete="off" class="!tw-w-full" formControlName="email"
              placeholder="{{ 'auth.shared.labels.email' | translate }}" required
            />
            <kendo-formerror translate>auth.shared.errors.email</kendo-formerror>
          </kendo-formfield>
          <kendo-formfield uiShowErrorAfterBlur class="tw-mb-5">
            <kendo-label
              class="tw-pb-1 tw-text-lg tw-font-bold tw-text-base-text/60 tw-pointer-events-none"
              text="{{ 'auth.sign_in.labels.password' | translate }}" 
              [for]="password"
            ></kendo-label>
            <input
              #password kendoTextBox
              autocomplete="off" class="!tw-w-full" formControlName="password"
              placeholder="{{ 'auth.sign_in.labels.password' | translate }}"
              type="password" required
            />
            <kendo-formerror translate>auth.sign_in.errors.password</kendo-formerror>
          </kendo-formfield>

          <button kendoButton class="tw-w-full tw-mt-3 tw-mb-5" type="submit" themeColor="secondary" [disabled]="actionDisabled$ | async">
            <span class="tw-flex tw-items-center">
              <span class="tw-mr-2 tw-uppercase" translate>auth.sign_in.actions.sign_in</span>
              <kendo-loader *ngIf="loading$ | async" class="tw-ml-2" type="pulsing" size="small" [themeColor]="'light'"></kendo-loader>
            </span>
          </button>

          <div class="tw-flex tw-justify-between tw-items-center">
            <a
              class="!tw-text-secondary !tw-font-normal"
              [class.disabled]="loading$ | async"
              (click)="forgotPassword($event)"
              translate
            >
              auth.sign_in.actions.forgot_password
            </a>
            <span [class.disabled]="loading$ | async" class="tw-flex tw-items-center tw-gap-2">
              <span class="tw-text-base-text/60" translate>auth.sign_in.labels.dont_have_account</span>
              <a
                class="tw-flex tw-items-center !tw-text-secondary !tw-font-normal"
                (click)="signUp()"
              >
                <span translate>auth.sign_in.actions.sign_up</span>
                <fa-icon class="tw-ml-2" [icon]="icons.faUpRightFromSquare"></fa-icon>
              </a>
            </span>
          </div>
        </form>
      </div>
      <div class="tw-relative tw-flex tw-justify-center tw-mb-4 tw-hidden">
        <div class="divider tw-flex tw-justify-between tw-items-center">
          <hr>
          <hr>
        </div>
        <span class="tw-text-base-text/40 tw-text-center tw-italic" translate>auth.sign_in.labels.or</span>
      </div>
      <button kendoButton class="google-button tw-w-full tw-hidden" type="submit" themeColor="light" [disabled]="loading$ | async">
        <span class="tw-flex tw-items-center">
          <img class="tw-mr-2" src="https://static-00.iconduck.com/assets.00/google-icon-2048x2048-czn3g8x8.png">
          <span translate>auth.sign_in.actions.google</span>
        </span>
      </button>
    </div>
  </ui-popup-body>
</ui-popup-layout>
